import React, { FC } from 'react';
import { getProtectedImageUriFromString } from '../../../utils/FileAccessUtils';
import { ROLE_TYPES } from '../../../utils/DataConstants';
import { FileOutlined } from '@ant-design/icons';

const ImageDisplay = ({ fileIdWithName }) => {
	const completePath = getProtectedImageUriFromString(ROLE_TYPES.BUYER)(fileIdWithName);
	const onClick = () => {
		window.open(completePath, '_blank', 'noreferrer');
	};
	return (
		<div className="border-[1px] border-solid border-gray-300 p-2">
			<div
				style={{
					backgroundImage: `url(${getProtectedImageUriFromString(ROLE_TYPES.BUYER)(
						fileIdWithName
					)})`,
					cursor: 'pointer',
				}}
				onClick={onClick}
				className={`h-[86px] w-[86px] bg-cover`}
			/>
		</div>
	);
};

const PdfDisplay = ({ fileIdWithName }) => {
	const [_, fileName] = fileIdWithName.split('/');
	const completePath = getProtectedImageUriFromString(ROLE_TYPES.BUYER)(fileIdWithName);
	const onClick = () => {
		window.open(completePath, '_blank', 'noreferrer');
	};

	return (
		<div className="flex items-center justify-center border-[1px] border-solid border-gray-300 p-2 text-center">
			<div
				className={`flex h-[86px] w-[86px] cursor-pointer flex-row items-center gap-2 bg-cover text-sm`}
				onClick={onClick}
			>
				<span>
					<FileOutlined />
					{` ${fileName}`}
				</span>
			</div>
		</div>
	);
};

const TroubleshootingAttachmentsDisplay: FC<any> = ({ attachments = [] }) => {
	return attachments.length > 0 ? (
		<div className="flex flex-row items-start gap-2">
			{attachments.map((att, idx) => {
				return att.attachmentType === 'pdf' ? (
					<PdfDisplay fileIdWithName={att.fileIdWithName} />
				) : (
					<ImageDisplay key={`image-${idx}`} fileIdWithName={att.fileIdWithName} />
				);
			})}
		</div>
	) : null;
};

export default TroubleshootingAttachmentsDisplay;
